import { useMutation } from '@tanstack/react-query'
import { createOrderTicket, markTicketCopied } from '@/lib/orderTicketApi'
import type { OrderTicketRequest } from '@/types/orderTicket'

export function useGenerateOrderTicket(positionId: number) {
  return useMutation({
    mutationFn: (body: OrderTicketRequest) => createOrderTicket(positionId, body),
  })
}

export function useMarkTicketCopied() {
  return useMutation({
    mutationFn: markTicketCopied,
  })
}
